import React from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import ArrowheadDown from '@elliemae/ds-icons/ArrowheadDown';
import ArrowheadUp from '@elliemae/ds-icons/ArrowheadUp';

var blockName = 'data-grid-sort-header';
var SortHeaderContainer = aggregatedClasses('div')(blockName);
var iconColor = ['brand-primary', 800];
var SortHeader = /*#__PURE__*/React.memo(function (_ref) {
  var value = _ref.value,
      onClick = _ref.onClick,
      sortState = _ref.sortState;
  var sortIndicator = sortState === 'asc' ? /*#__PURE__*/React.createElement(ArrowheadUp, {
    color: iconColor
  }) : /*#__PURE__*/React.createElement(ArrowheadDown, {
    color: iconColor
  });
  return /*#__PURE__*/React.createElement(SortHeaderContainer, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "header-value"
  }, value), sortState && sortIndicator);
});

var sortHeaderFormatter = function sortHeaderFormatter(sortable, grid) {
  return function (value, _ref2) {
    var columnIndex = _ref2.columnIndex,
        property = _ref2.property;

    var _grid$getInstance = grid.getInstance(),
        sortingColumns = _grid$getInstance.state.sortingColumns;

    var _sortable = sortable(value, {
      columnIndex: columnIndex,
      property: property
    }),
        onClick = _sortable.onClick,
        className = _sortable.className;

    return /*#__PURE__*/React.createElement(SortHeader, {
      className: className,
      onClick: onClick,
      sortState: sortingColumns[property] && sortingColumns[property].direction,
      value: value
    });
  };
};

export default sortHeaderFormatter;
//# sourceMappingURL=sortHeaderFormatter.js.map
